export enum ModalTestingId {
  bottomModalOverlay = "BOTTOM_MODAL_OVERLAY",
}

export enum DateFormatType {
  dateFormatwithSlash = "dd/mm/yyyy",
}
